import { createApi } from "@reduxjs/toolkit/query/react";
import { Endpoints, convertTag } from "services/urls";
import { baseQuery } from "utils/baseQuery";
import { IForms } from "../types/forms.types";
import { apiHelper } from "../utils/apiHelper";
import { IRequests, IRequestsQuery } from "../types/requests.types";
import { APPLICATIONS_TAGS } from "constants/API_TAGS";

const RequestsApi = createApi({
  reducerPath: "requests-api",
  baseQuery: baseQuery(),
  tagTypes: [APPLICATIONS_TAGS.list, APPLICATIONS_TAGS.pending],
  endpoints: (builder) => ({
    // forms list
    requestList: builder.query<IRequests, IRequestsQuery>({
      providesTags: [convertTag(APPLICATIONS_TAGS.list)],
      query: (body) => apiHelper(Endpoints.requests.list, body),
      // serializeQueryArgs: ({ queryArgs }) => {
      //   const { page, ...otherQuery } = queryArgs;
      //   return otherQuery;
      // },
      // merge: (currentCache, newItems) => {
      //   if (typeof newItems === "object" && Array.isArray(newItems.data)) {
      //     if (currentCache.data !== newItems.data)
      //       // @ts-ignore
      //       [...new Set(currentCache.data)].flat().push(...newItems.data);
      //   }
      // },
      // forceRefetch({ currentArg, previousArg }) {
      //   return currentArg !== previousArg;
      // },
    }),
    requestPendingAction: builder.query<IForms, unknown>({
      providesTags: [
        convertTag(APPLICATIONS_TAGS.pending),
        convertTag(APPLICATIONS_TAGS.list),
      ],
      query: (body) => apiHelper(Endpoints.requests.pendingActionList, body),
    }),
  }),
});

export const {
  useRequestListQuery,
  useRequestPendingActionQuery,
  useLazyRequestListQuery,
} = RequestsApi;
export { RequestsApi };
